module.exports = __webpack_public_path__ + "img/36.7598efe8.png";